import { render, staticRenderFns } from "./WizardPage1.vue?vue&type=template&id=5cb1022e"
import script from "./WizardPage1.vue?vue&type=script&lang=js"
export * from "./WizardPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports